export default __webpack_public_path__ + "static/media/GenWanMinTW-R-01.8ff3afbb.woff";